import React from 'react'

import { AceHardwareLabel } from './AceHardwareLabel'
import { AmazonLabel } from './AmazonLabel'
import { AmazonCaseLabel } from './AmazonCaseLabel'
import { FleetFarmCaseLabel } from './FleetFarmLabel'
import { GenericPalletLabel } from './GenericPalletLabel'
import { GenericCaseLabel } from './GenericCaseLabel'
import { HomeDepotLabel } from './HomeDepotLabel'
import { HomeDepotCaseLabel } from './HomeDepotCaseLabel'
import { LowesLabel } from './LowesLabel'
import { OceanStateLabel } from './OceanStateLabel'
import { TargetLabel } from './TargetLabel'
import { TractorSupplyLabel } from './TractorSupplyLabel'
import { TrueValueLabel } from './TrueValueLabel'
import { WalmartLabel } from './WalmartLabel'

interface Props {
  data: any
  onReadyToPrint?: () => void
}

const retailerLabelFormats: { [key: string]: React.FC<Props> } = {
  ace: AceHardwareLabel,
  ace_case: AceHardwareLabel,
  amazon: AmazonLabel,
  amazon_case: AmazonCaseLabel,
  fleet_farm_case: FleetFarmCaseLabel,
  generic_pallet: GenericPalletLabel,
  generic_case: GenericCaseLabel,
  home_depot: HomeDepotLabel,
  home_depot_case: HomeDepotCaseLabel,
  lowes: LowesLabel,
  ocean_state_case: OceanStateLabel,
  target: TargetLabel,
  tractor_supply: TractorSupplyLabel,
  true_value: TrueValueLabel,
  walmart: WalmartLabel,
}

const DefaultLabel = () => {
  return <span>Unrecognized retailer.</span>
}

export const RetailerLabel = (props: Props) => {
  const { data, onReadyToPrint } = props
  const Label = retailerLabelFormats[data.label_format as string] || DefaultLabel

  return <Label data={data} onReadyToPrint={onReadyToPrint} />
}
